import type { ReactElement } from "react";
import { Datagrid, FunctionField, TextField, useListContext } from "react-admin";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { useNavigate } from "react-router";
import { grants } from "../../backoffice.access_control";
import { Column } from "../../misc/Column";
import { Label } from "../../misc/Label";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import type { DrivingSchoolLabel } from "../../providers/drivingSchoolLabelsProvider";
import { LabelMobileListItem } from "./LabelMobileListItem";

export function LabelsDataGrid(props: { empty?: ReactElement }) {
  const { empty } = props;
  const { isLoading, data, total } = useListContext<DrivingSchoolLabel>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const rowClick = grants.has("DrivingSchoolLabel:edit") ? "edit" : false;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isMobile) {
    if (!data || data.length === 0 || total === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((label) => (
          <LabelMobileListItem
            key={label.id}
            label={label}
            onClick={rowClick === false ? undefined : () => navigate(`/labels/${label.id}`)}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid rowClick={rowClick} bulkActionButtons={false} empty={empty}>
      <FunctionField
        label="Label"
        source="name"
        render={(record: DrivingSchoolLabel) => <Label label={record} hideTooltip />}
      />
      <TextField label="Beschreibung" source="description" />
      <TextField label="Anzahl Fahrschüler" source="usageCount" />
    </Datagrid>
  );
}
